export const FULFILLMENT_VALUES = {
  YES: 'yes',
  NO: 'no',
} as const;

export const NUMERIC_VALUES = {
  YES: 1,
  NO: 0,
} as const;
